import { getApiClient } from '@lib/apiClient';

/**
 * Check if the current token has a specific scope/permission.
 * Also verifies the token is not expired.
 *
 * Call this inside event handlers where you need the current state.
 * NOT a React hook - can be called anywhere.
 *
 * @param scope The scope to check (e.g., "security")
 * @returns true if the token has the scope and is not expired
 */
export function hasScope(scope: string): boolean {
    return getApiClient().hasScope(scope);
}

/**
 * Get the current access token.
 * NOT a React hook - can be called anywhere.
 *
 * @returns the current JWT token, or null if not logged in
 */
export function getToken(): string | null {
    return getApiClient().getToken() ?? null;
}

/**
 * Extract email from the current access token.
 * NOT a React hook - can be called anywhere.
 *
 * @returns email from token claims, or null if not available
 */
export function getEmailFromToken(): string | null {
    return getApiClient().getEmailFromToken() ?? null;
}
